import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  let check = localStorage.getItem("user_token");

  // console.log(check);

  return check ? (
    children
  ) : (
    <>
      {" "}
      <Navigate to="/login" />{" "}
    </>
  );
};

export default PrivateRoute;
